import { inject } from '@angular/core';
import { CanActivateFn, Route, Router } from '@angular/router';
import { LayoutComponent } from './layout/layout.component';
import { FinancialSupportStore } from '../stores/financial-support.store';

const financialSupportSessionGuard: CanActivateFn = () => {
  const store = inject(FinancialSupportStore);
  if ((store.caseId() && store.accessToken()) || store.effectiveResult()) {
    return true;
  }
  return inject(Router).createUrlTree(['/index']);
};

const wizardRedirects: Route[] = [
  'analysis',
  'policy-funds',
  'policy-matches',
  'amount',
  'simulation',
  'status',
  'confirm',
  'company',
].map((path) => ({ path, redirectTo: 'index', pathMatch: 'full' }));

const reportRedirects: Route[] = ['review', 'comparison'].map((path) => ({
  path,
  redirectTo: 'report',
  pathMatch: 'full',
}));

export const appRoutes: Route[] = [
  {
    path: '',
    data: { layout: 'default' },
    component: LayoutComponent,
    children: [
      { path: '', loadComponent: () => import('./pages/preview/preview.page') },
      { path: 'intro', loadComponent: () => import('./pages/intro/intro.page') },
      {
        path: 'index',
        loadComponent: () => import('./pages/index/index.page'),
        data: { showBanner: true },
      },
      {
        path: 'analyzing',
        loadComponent: () => import('./pages/analyzing/analyzing.page'),
        canActivate: [financialSupportSessionGuard],
        data: { showBanner: true },
      },
      {
        path: 'report',
        loadComponent: () => import('./pages/report/report.page'),
        canActivate: [financialSupportSessionGuard],
        data: { showBanner: true },
      },
      ...wizardRedirects,
      ...reportRedirects,
      { path: 'log', loadComponent: () => import('./pages/log/log.page') },
    ],
  },
];
